export const UNITS_OF_MEASUREMENT = [
    "",
    "mm",
    "m",
    "m2",
    "m3",
    "pcs",
    "pkg",
    "g",
    "kg",
    "ml",
    "l",
] as const;

export type UnitOfMeasurement = typeof UNITS_OF_MEASUREMENT[number];
